import React, { useContext } from 'react';
import { Container, Box, Grid, IconButton, Link } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsappIcon from '@mui/icons-material/WhatsApp';
import '../styles/css/Footer.css';
import Reveal from './common/Reveal';
import { LanguageContext } from '../App';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { language, translations } = useContext(LanguageContext);
  
  return (
    <Box component="footer" id="site-footer" className="footer">
      <Container>
        <Reveal>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box className="footer-branding">
              <Box className="footer-logo">                
                <h3 className="footer-brand">
                  {translations[language].footerBrand}
                </h3>
              </Box>
              <Box className="footer-social">
                <IconButton color="inherit" aria-label="Facebook" component="a" href="https://facebook.com/ramipazhar" target="_blank">
                  <FacebookIcon />
                </IconButton>
                <IconButton color="inherit" aria-label="Instagram" component="a" href="https://instagram.com/ramipazhar" target="_blank">
                  <InstagramIcon />
                </IconButton>
                <IconButton color="inherit" aria-label="Twitter" component="a" href="https://wa.me/972524636767" target="_blank">
                  <WhatsappIcon />
                </IconButton>                
              </Box>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6} md={4}>
            <h3 className="footer-heading">
              {translations[language].footerLinksTitle}
            </h3>
            <ul className="footer-links">
              {translations[language].footerLinks.map(link => (
                <li key={link.id}><Link href={link.href} color="inherit">{link.label}</Link></li>
              ))}
            </ul>
          </Grid>
          
          
        </Grid>
        </Reveal>
        
        <Box className="footer-bottom">
          <p className="footer-copyright">
            &copy; 2026 {translations[language].footerCopyright}
          </p>          
          <p className="footer-copyright">
            {translations[language].footerFonts}
          </p>          
          

        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
